<template>
  <div>
    <b-modal
      title="Snapshot enqued"
      class="modal-success"
      v-model="successModal"
      ok-only
      ok-variant="success"
      @ok="refreshGridData"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >Snaphshot of store's data was enqued for processing. It might take some time to finish it.</b-modal>
    <b-modal
      title="Error happened"
      class="modal-danger"
      v-model="errorModal"
      ok-only
      ok-variant="danger"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >{{errorMessage}}</b-modal>
    <kendo-datasource
      ref="grid-datasource"
      :transport="transport"
      :schema="schema"
      :serverPaging="true"
      :serverSorting="true"
      :page-size="5"
      :sort="sort"
    ></kendo-datasource>
    <kendo-grid
      :data-source-ref="'grid-datasource'"
      ref="extractgrid"
      :selectable="'row'"
      :sortable="sortable"
      :filterable="false"
      :groupable="false"
      :toolbar="toolbarTemplate"
      :pageable="pageable"
      :pageable-always-visible="true"
      :auto-bind="true"
    >
      <kendo-grid-column :template="selectExtractTemplate" :width="100"></kendo-grid-column>
      <kendo-grid-column field="type" title="Snapshot type"></kendo-grid-column>
      <kendo-grid-column field="status" title="Status"></kendo-grid-column>
      <kendo-grid-column title="Created" field="created" :template="createdTemplate"></kendo-grid-column>
      <kendo-grid-column title="Completed" field="completed" :template="completedTemplate"></kendo-grid-column>
    </kendo-grid>
  </div>
</template>

<script>
import Vue from "vue";
import "@progress/kendo-ui";
import "@progress/kendo-theme-default/dist/all.css";
import { Grid, GridInstaller } from "@progress/kendo-grid-vue-wrapper";
import { DataSource, DataSourceInstaller } from '@progress/kendo-datasource-vue-wrapper'
import { format, render, cancel, register } from 'timeago.js';

import Template from "./ExtractGridSelectColumn.vue";
var custTemplate = Vue.component(Template.name, Template);

Vue.use(GridInstaller);
Vue.use(DataSourceInstaller)


export default {
  name: "extractgrid",
  props: {
    type: String,
    shopifyStoreId: String
  },
  data: function () {
    var self = this;
    return {
      successModal: false,
      errorModal: false,
      errorMessage: "",
      pageable: {
        refresh: false,
        pageSizes: [5, 10, 50],
        messages: {
          display: "{0}-{1} of {2} snapshots",
          itemsPerPage: "snapshots per page"
        }
      },
      sortable: {
        allowUnsort: false,
        mode: "single"
      },
      transport: {
        read: async (options) => {
          try {
            let response = await Vue.axios.get(process.env.VUE_APP_API_URL + `shopify/list-extracts/${process.env.VUE_APP_BOUGHT_TOGETHER_APP_NAME}/${self.type}/${self.shopifyStoreId}?take=${options.data.take}&skip=${options.data.skip}&orderby=${options.data.sort[0].field}&desc=${options.data.sort[0].dir == 'desc'}`);
            options.success(response.data);
          }
          catch (error) {
            debugger
            console.log(error.statusText);
            options.error(error.statusText);
          }
        }
      },
      schema: {
        data: function (data) {
          return data.items;
        },
        model: {
          id: "id",
          fields: {
            id: { from: "id" },
            completed: { from: "completed", type: "date" },
            created: { from: "created", type: "date" },
            status: { from: "status" }
          }
        },
        total: function (data) {
          return data.total;
        }
      },
      sort: {
        field: "created",
        dir: "desc"
      }
    };
  },
  mounted: function () {
    let self = this;
    var grid = this.$refs.extractgrid.kendoWidget();
    var toolbarEl = grid.element.find('.k-grid-toolbar');
    toolbarEl.on("click", ".k-pager-refresh", function (e) {
      e.preventDefault();
      grid.dataSource.read();
    });
    toolbarEl.on("click", ".k-pager-plus", function (e) {
      e.preventDefault();
      self.createExtract();
    });
  },
  methods: {
    createdTemplate(e) {
      return format(e.created);
    },
    completedTemplate(e) {
      return e.status == "Completed" ? format(e.completed) : "Not completed";
    },
    selectExtractTemplate: function (e) {
      let self = this;
      return {
        template: custTemplate,
        templateArgs: {
          data: {
            show: e.status == "Completed"
          },
          callback: function () {
            self.$emit('extract-selected', e);
          }
        }
      }
    },
    refreshGridData: function () {
      var grid = this.$refs.extractgrid.kendoWidget().dataSource.read();;
    },
    toolbarTemplate: function () {
      var templateHtml =
        "<span>" +
        '<a class="k-pager-refresh k-link k-button" title="Refresh"><span class="k-icon k-i-reload"></span></a>' +
        "</span>" +
        '<span style="position:absolute; right:15px">' +
        '<a class="k-pager-plus k-link k-button" title="Generate"><span class="k-icon k-i-plus"></span>GENERATE NEW SNAPSHOT</a>' +
        "</span>";
      return kendo.template(templateHtml);
    },
    onChange: function (ev) {
      var selected = $.map(ev.sender.select(), function (item) {
        return $(item).text();
      });

      console.log(
        "Selected: " +
        selected.length +
        " item(s), [" +
        selected.join(", ") +
        "]"
      );
    },
    createExtract: async function () {
      try {
        let response = await Vue.axios.post(new URL(process.env.VUE_APP_API_URL + `shopify/dataextract/${this.type.toLowerCase()}/create?storeId=${this.shopifyStoreId}&applicationName=${process.env.VUE_APP_BOUGHT_TOGETHER_APP_NAME}`), {});
        this.$data.successModal = true;
        this.refreshGridData();
      } catch (error) {
        this.$data.errorMessage = error.response ? error.response.data : "Error happened while creating a snapshot. Please contact support.";
        this.$data.errorModal = true;
      }
    }
  }
};
</script>
<style lang="scss">
@import "@/styles/grid.scss";
</style>